// react
import React, { Component, useEffect } from "react";

// third-party
import classNames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// application
import departmentsAria from "../../services/departmentsArea";
import languages from "../../i18n";
import StroykaSlick from "../shared/StroykaSlick";
import * as GENERAL from "../../api/general";

const slickSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    lazyLoad: true,
    speed: 1000,
    autoplaySpeed: 7000,
    slidesToShow: 1,
    slidesToScroll: 1,
};

class BlockAnnouncementCarousel extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {}

    render() {
        const { announcements } = this.props;

        const slides =
            announcements.length > 0
                ? announcements.map((announcement, index) => {
                      return (
                          <div key={index} className="announcement-item block-slideshow__slide">
                              <h3>{announcement.title}</h3>
                              <img
                                  src={announcement.images[0] ? announcement.images[0].url : null}
                                  style={{ height: "350px", objectFit: "contain" }}
                              />
                              <p>{announcement.message}</p>
                          </div>
                      );
                  })
                : null;

        return announcements ? (
            <div className="announcement-slideshow">
                <div className="block-slideshow__body">
                    <StroykaSlick {...slickSettings}>
                        {slides}
                    </StroykaSlick>
                </div>
            </div>
        ) : null;
    }
}

export default BlockAnnouncementCarousel;
